import {Component, forwardRef, Injector, Input, OnInit} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {CustomObjectAssociationContext, CustomObjectTypeSearchModel} from "../custom-object-type-search.model";
import {
    CustomObjectTypeSearchPageComponent
} from "../custom-object-type-search-page/custom-object-type-search-page.component";
import {
    CustomObjectTypeEditPageComponent
} from "../custom-object-type-edit-page/custom-object-type-edit-page.component";
import {
    InventoryCustomObjectTypeSearchPageComponent
} from "../custom-object-type-search-page/inventory-custom-object-type-search-page.component";
import {
    ProductLineCustomObjectTypeSearchPageComponent
} from "../custom-object-type-search-page/product-line-custom-object-type-search-page.component";
import {
    OutletCustomObjectTypeSearchPageComponent
} from "../custom-object-type-search-page/outlet-custom-object-type-search-page.component";
import {
    MembershipTypeCustomObjectTypeSearchPageComponent
} from "../custom-object-type-search-page/membership-type-custom-object-type-search-page.component";
import {
    ProductLineCustomObjectTypeEditPageComponent
} from "../custom-object-type-edit-page/product-line-custom-object-type-edit-page.component";
import {
    InventoryCustomObjectTypeEditPageComponent
} from "../custom-object-type-edit-page/inventory-custom-object-type-edit-page.component";
import {
    OutletCustomObjectTypeEditPageComponent
} from "../custom-object-type-edit-page/outlet-custom-object-type-edit-page.component";
import {
    MembershipTypeCustomObjectTypeEditPageComponent
} from "../custom-object-type-edit-page/membership-type-custom-object-type-edit-page.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CustomObjectTypeSingleSelectEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-custom-object-type-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        CUSTOM_VALUE_ACCESSOR,
        provideSearchModel(CustomObjectTypeSearchModel)
    ]
})
export class CustomObjectTypeSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<CustomObjectTypeSearchModel> implements OnInit {
    @Input() productLineContext: boolean;
    @Input() inventoryContext: boolean;
    @Input() outletContext: boolean;
    @Input() membershipTypeContext: boolean;

    constructor(model: CustomObjectTypeSearchModel, injector: Injector) {
        super(model, injector, "customObjectTypeId", "name");
    }

    override ngOnInit(): void {
        super.ngOnInit();
        if (this.productLineContext) {
            this.model.filter[CustomObjectTypeSearchModel.CONTEXT_FILTER_NAME] = CustomObjectAssociationContext.PRODUCT_LINE;
            this.extendedSearchComponent = ProductLineCustomObjectTypeSearchPageComponent;
            this.extendedEditComponent = ProductLineCustomObjectTypeEditPageComponent;
        } else if (this.inventoryContext) {
            this.model.filter[CustomObjectTypeSearchModel.CONTEXT_FILTER_NAME] = CustomObjectAssociationContext.INVENTORY;
            this.extendedSearchComponent = InventoryCustomObjectTypeSearchPageComponent;
            this.extendedEditComponent = InventoryCustomObjectTypeEditPageComponent;
        } else if (this.outletContext) {
            this.model.filter[CustomObjectTypeSearchModel.CONTEXT_FILTER_NAME] = CustomObjectAssociationContext.OUTLET;
            this.extendedSearchComponent = OutletCustomObjectTypeSearchPageComponent;
            this.extendedEditComponent = OutletCustomObjectTypeEditPageComponent;
        } else if (this.membershipTypeContext) {
            this.model.filter[CustomObjectTypeSearchModel.CONTEXT_FILTER_NAME] = CustomObjectAssociationContext.MEMBERSHIP_TYPE;
            this.extendedSearchComponent = MembershipTypeCustomObjectTypeSearchPageComponent;
            this.extendedEditComponent = MembershipTypeCustomObjectTypeEditPageComponent;
        } else {
            this.extendedSearchComponent = CustomObjectTypeSearchPageComponent;
            this.extendedEditComponent = CustomObjectTypeEditPageComponent;
        }
    }
}
